/**
 * Picks the variant root for a pathname, falling back to the base app.
 *
 * Matches on segment boundaries rather than a bare prefix, so `/financeteam`
 * and `/finance-old` stay on the base app while `/finance` and `/finance/x`
 * resolve to the Finance variant.
 *
 * Kept as a pure function so it is testable — the caller in main.tsx is
 * top-level module code that no test can reach.
 */
export function resolveVariantApp<T>(
  pathname: string,
  registry: Record<string, T>,
  fallback: T
): T {
  const key = Object.keys(registry).find((p) => pathname === p || pathname.startsWith(p + '/'))
  return key ? registry[key] : fallback
}
